<template>
    <div class="slider slider1">
        
       <!-- <div class="play-icon" :class="isWebpayEnable === '1' ? 'iconLr' : 'iconLf'">
        <div v-if="isPlay" class="close-music-icon icon-size " @click="open_voice()"></div>
        <div v-else class="open-music-icon icon-size " @click="close_voice()"></div>
       </div> -->

        <div class="l-cnt">
            <div class="logo"></div>
            <div class="btn-list cursor">
                <div class="google-btn btn-size" @click="GP_download('gp')"></div>
                <div class="ios-btn btn-size" @click="AS_download('as')"></div>
                <div class="os-btn btn-size" @click="OS_download('os')"></div>

            </div>
            <!-- <div class="btn cursor" @click="handleGo()">
                <picture class="picture">
                    <source type="image/webp" srcset="../../assets/img/m1/regbtn.webp" />
                    <img class="image" src="../../assets/img/m1/regbtn.png" width="100%" />
                </picture>
            </div> -->

        </div>
        <div class="bgCover"></div>
        <div class="embed-responsive-16by9 videobox">
            <video loop muted autoplay class="video-bg2 video-size" id="bgVideo" ref="bgVideo">
                <source src="https://resource-mp4.ujoygames.com/qyhx/bg2.mp4" type="video/mp4" />
            </video>
        </div>
    </div>
</template>

<script>

export default {
    props: ["onNext", "webpayEnable"],

    created() {
    },
    data() {
        return {
            isPlay: true,
            // isWebpayEnable: 1
        };
    },
    watch: {
     
    },
    created() {
    },
    methods: {

        open_voice() {
            let bgVideo = this.$refs.bgVideo;
            bgVideo.muted = false
            this.isPlay = false
        },
        close_voice() {
            let bgVideo = this.$refs.bgVideo;
            bgVideo.muted = true
            this.isPlay = true
        },
        // handleGo() {
        //     this.$emit('handleInvite')
        // }
        GP_download(val) {
            this.common.goStore(val)
        },
        AS_download(val) {
            this.common.goStore(val)
        },
        OS_download(val) {
            this.common.goStore(val)
        },

    },
};
</script>

<style lang="scss" scoped>
.slider1 {
    background: url("../../assets/img/m1/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    /**
    .open-music-icon {
        background: url("../../assets/img/common/music-note.png") no-repeat top;
        background-size: 100% 100%;

    }

    .close-music-icon {
        background: url("../../assets/img/common/music-note-off.png") no-repeat top;
        background-size: 100% 100%;

    }
    .play-icon {
        position: absolute;
        right: 330px;
        top: 24px;
        z-index: 2;
        cursor: pointer;
    }
    .iconLf {
        right: 230px;

    }
    .iconLr {
        right: 330px;

    }
    .icon-size {
        width: 48px;
        height: 48px;
       
    }
 */
    .bgCover {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: url("../../assets/img/m1/cover_pattern.png");

        z-index: 3;
    }

    .bg1 {
        width: 100%;
        height: 100%;
    }

    .l-cnt {
        top: 550px;
        left: 50%;
        position: absolute;
        transform: translate(-50%, 0);
        z-index: 4;

        .logo {
            background: url("../../assets/img/m1/logo.png") no-repeat top;
            background-size: 100% 100%;
            width: 563px;
            height: 189px;
            margin: 0 auto 16px auto;

        }

        .btn-list {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 650px;
            margin: 0 auto;

            .google-btn {
                background: url("../../assets/img/m1/button-google.png") no-repeat top;
                background-size: 100% 100%;
            }

            .ios-btn {
                background: url("../../assets/img/m1/button-apple.png") no-repeat top;
                background-size: 100% 100%;
            }

            .os-btn {
                background: url("../../assets/img/m1/button-one.png") no-repeat top;
                background-size: 100% 100%;
            }

            .btn-size {
                width: 204px;
                height: 61px;
                margin: 0 auto;
            }
        }


    }



    .videobox {
        position: relative;
        height: 100vh;
        /*进行视频裁剪*/
        overflow: hidden;

        .video-size {
            position: absolute;
            left: 50%;
            top: 50%;
            /*保证视频内容始终居中*/
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
            /*保证视频充满屏幕*/
            object-fit: cover;
            min-height: 800px;
        }

        .video-bg1 {
            z-index: 2;
        }

        .video-bg2 {
            z-index: 1;
        }
    }



}


@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .l-cnt {
        top: 470px !important;

        .logo {

            width: 479px !important;
            height: 161px !important;

        }

        .btn {

            width: 163px !important;
            height: 48px !important;
        }
    }



}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider1.vue